angular
    .module('annexaApp')
	.controller('RelationshipLanguageController',['$scope', '$rootScope', 'CommonAdminModals', 'AnnexaFormlyFactory', 'RestService', 'AnnexaModalFactory', 'Language', '$filter', 'GlobalDataFactory', 'CacheFactory', 'apiAdmin', 'DialogsFactory',
    	function($scope, $rootScope, CommonAdminModals, AnnexaFormlyFactory, RestService, AnnexaModalFactory, Language, $filter, GlobalDataFactory, CacheFactory, apiAdmin, DialogsFactory) {

			$scope.filter = [
				{ id: Language.getActiveColumn(), type: 'text', order: 0, label: 'global.literals.name'}
			];

			$scope.newElement = function() {
				var modal = angular.copy(CommonAdminModals.relationshipLanguageNew);
				modal.annexaFormly.model = {};
				modal.annexaFormly.model.modal_body = {};
				modal.annexaFormly.options = {};
				
				AnnexaFormlyFactory.showModal('modalNewRelationshipLanguage', modal, $scope.saveRelationshipLanguage, false);
			}

			$scope.saveRelationshipLanguage = function (relationshipLanguage) {
				var modal = this;
				
				var model = {
					language1: relationshipLanguage.annexaFormly.model.modal_body.language1 ? relationshipLanguage.annexaFormly.model.modal_body.language1 : 'NotTranslated',
					language2: relationshipLanguage.annexaFormly.model.modal_body.language2 ? relationshipLanguage.annexaFormly.model.modal_body.language2 : 'NotTranslated',
					language3: relationshipLanguage.annexaFormly.model.modal_body.language3 ? relationshipLanguage.annexaFormly.model.modal_body.language3 : 'NotTranslated'
				}
				
				RestService.insert('./api/thirds/relationship_language', model).then(function () {
					$rootScope.$broadcast('annexaAdminBaseReloadTable'); 
					modal.close();
				}).catch(function (error) {
					modal.alerts.push({ msg: $filter('translate')('global.errors.errorRelationshipLanguage')});
				})
			}

			$scope.viewElement = function (id) {
				RestService.findOne('RelationshipLanguage', id).then(function(data) {
					var decodeddata = JSOG.decode(data.data);
					
					var modal = angular.copy(CommonAdminModals.relationshipLanguageEdit);
					modal.alerts = [];
					modal.data = decodeddata;
					modal.languageColumn = Language.getActiveColumn();
					modal.updateRelationshipLanguage = $scope.updateRelationshipLanguage;
					
					AnnexaModalFactory.showModal('modalRelationshipLanguageEdit', modal);
				});
			}

			$scope.updateRelationshipLanguage = function(val, prop) {
				var self = this;
				var model = angular.copy(this.data);
				
				RestService.update('./api/thirds/relationship_language/' + model.id, model).then(function (data) {
					$rootScope.$broadcast('annexaAdminBaseReloadTable');
				}).catch(function (error) {
					DialogsFactory.error($filter('translate')('global.errors.errorRelationshipLanguage'));
				});
			}
	}])